<template>
  <component :is="tag" v-if="distance" style="padding: 0 !important;">
    <div :dir="uiDirection" class="bidi inCellHeight" :class="setRangeColor()">
      {{label}}
<!--      <i class="ri-arrow-down-line" v-if="priceDirection === 'down'"/>-->
<!--      <i class="ri-arrow-up-line" v-if="priceDirection === 'up'"/>-->
    </div>
  </component>
  <component :is="tag" :dir="uiDirection" class="bidi" style="padding: 0 !important;" v-else>
    {{ value ? value : '-' }}
  </component>
</template>

<script>

import {useEquityPrices} from "../../stores/equityPrices";
import {useNewYorkTime} from "../../stores/newYorkTime";
import {getCurrentInstance} from "vue";

export default {
  name: "PriceDistance",
  props: ['symbol', 'defaultPrice', 'value', 'threshold', 'direction', 'tag', 'previousClose'],
  data() {
    return {
      isInitialLoad: true,
      lastPrice: this.symbol?.price,
      lastPrePostPrice: null,
      latestDistance: null
    }
  },
  setup() {
    const nyTime = useNewYorkTime()
    const equityPrices = useEquityPrices();
    return {nyTime, equityPrices};
  },
  mounted() {
  },
  computed: {
    label() {

      return this.distance + '%' + ' ' + (this.previousClose > this.value ? this.dictionary.symbolPage.below : this.dictionary.symbolPage.above) + ' ' + this.dictionary.symbolPage.price.toLowerCase();
    },
    priceDirection() {

      if (!this.previousClose) return null;
      let price = this.equityPrices?.prices?.[this.symbol]?.price || this.defaultPrice;
      return price > this.previousClose ? 'up' : 'down';
    },
    distance() {

      try {

        let price = this.previousClose //this.equityPrices?.prices?.[this.symbol]?.price || this.defaultPrice;
        const delta = parseFloat((((this.value - price) / price) * 100).toFixed(2));

        if (delta !== this.latestDistance && !isNaN(delta)) {
          this.latestDistance = delta;
          this.$emit('deltaChange', delta);
        }

        if (delta > 50) {
          return `> 50`
        } else if (delta < -50) {
          return '< -50'
        } else {
          return delta;
        }
      } catch (e) {

        return null;
      }
    },
    inRange() {

      if (!this.threshold) return false;
      let price = this.equityPrices?.prices?.[this.symbol]?.price || this.defaultPrice;
      return (Math.abs(price - this.value) / this.value) <= (this.threshold / 100)
    }
  },
  methods: {
    setRangeColor() {

      if (this.distance >= -3 && this.distance < -2) {
        return 'low';
      } else if (this.distance >= -2 && this.distance < -1) {
        return 'medium';
      } else if (this.distance >= -1 && this.distance <= 0) {
        return 'high';
      } else if (this.distance > 0 && this.distance <= 1) {
        return 'high';
      } else if (this.distance > 1 && this.distance <= 2) {
        return 'medium';
      } else if (this.distance > 2 && this.distance <= 3) {
        return 'low';
      }

      return null
    }
  },
}
</script>

<style scoped lang="scss">

td {
  padding: 0 !important;
  div, span {

    font-size: 14px;
  }
  * {
    font-size: 14px;
  }
}

.bidi {
  padding: 7px 8px !important;
}

.hoveredColumn {
  background: var(--tableHoverColor) !important;
}

.symbol {
  display: flex;
  gap: 5px;
  align-items: center;
  font-weight: 500;
  flex-wrap: nowrap;
}

.active {
  color: var(--textColor);
  transition: all .2s linear;
}

.low {
  background: rgba(245, 158, 11, 0.2) !important;

  &.active {
    @extend .active;
  }
}

.medium {
  background: rgba(245, 158, 11, 0.4) !important;

  &.active {
    @extend .active;
  }
}

.high {
  background: rgba(245, 158, 11, .8) !important;

  &.active {
    @extend .active;
  }
}

.topRange {
  color: var(--green);
  background: var(--opacityGreen);
  transition: all .2s linear;
}

.bottomRange {
  color: var(--red);
  background: var(--opacityRed);
  transition: all .2s linear;
}

</style>
